import { Box } from "components";

const Hobbies = () => (
  <Box aside title="My Hobbies & Interests" type="hobbies">
    <div>
      <p>
        - Music:&nbsp;
        <span style={{ color: "gray" }}>
          I play guitar, baglama(a Turkish musical instrument) and I can sing 😊
        </span>
      </p>
      <p>- Fitness</p>
      <p>- Swimming</p>
      <p>- Reading</p>
    </div>
  </Box>
);

export default Hobbies;
